import { useQuery, QueryClient } from '@tanstack/react-query';
import axios from "axios";
import { useStore } from "../appStore"

const queryClient = new QueryClient();
const key = 'organizationalRoles';
async function getOrganizationalRoles(organizationId) {
    const response = await axios.get(`api/Organization/${organizationId}/Roles`)
    return response.data;
}
async function getPermissionRolesDetail(orgId, roleId) {
    const response = await axios.get(`api/Organization/${orgId}/Roles/${roleId}`);
    return response.data;
}
async function getSystemPermissionDependency() {
    const response = await axios.get(`api/Permissions/Dependencies`);
    return response.data;
}
const useRolesQuery = () => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    return useQuery({ queryKey: ['organizationalRoles', orgId], queryFn: () => getOrganizationalRoles(orgId) });
}
const usePermissionRolesByRoleIdQuery = (roleId) => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    return useQuery({
        queryKey: ['permissionRoles', roleId, orgId], queryFn: () => getPermissionRolesDetail(orgId, roleId), staleTime: 1000 * 60 * 5
    });
}
const prefetchSystemPermissionDependency = () => {
    return queryClient.prefetchQuery({
        queryKey: ['systemPermissionDependency'],
        queryFn: () => getSystemPermissionDependency(),
        staleTime: 1000 * 60 * 5,
    });
}
const useSystemPermissionDependencyQuery = () => {
    return useQuery({
        queryKey: ['systemPermissionDependency'], queryFn: () => getSystemPermissionDependency(), staleTime: 1000 * 60 * 5
    });
}

export { useRolesQuery, usePermissionRolesByRoleIdQuery, useSystemPermissionDependencyQuery, prefetchSystemPermissionDependency, key };
